<section class="footer-area pt-100 pb-70">
    <div class="container">
        <div class="row">
            <!-- Logo & Beschreibung -->
            <div class="col-lg-3 col-sm-6">
                <div class="single-footer-widget">
                    <div class="logo">
                        <a href="#home"><img src="assets/img/logo.png" width="200" alt="Tommys Fahrschule Logo"/></a>
                    </div>
                    <p>Dein Weg zum Führerschein beginnt hier – schnell, flexibel und mit einem motivierten Team an deiner Seite.</p>
                    <ul class="social-list">
                        <li><a href="https://facebook.com" target="_blank"><i class="fab fa-facebook-f"></i></a></li>
                        <li><a href="https://instagram.com" target="_blank"><i class="fab fa-instagram"></i></a></li>
                        <li><a href="https://wa.me/491771482503" target="_blank"><i class="fab fa-whatsapp"></i></a></li>
                    </ul>
                </div>
            </div>

            <!-- Navigation -->
            <div class="col-lg-3 col-sm-6">
                <div class="single-footer-widget pl-5">
                    <h3>Navigation</h3>
                    <ul class="list">
                        <li><a routerLink="/">Start</a></li>
                        <li><a routerLink="/about">Über uns</a></li>
                        <li><a routerLink="/team">Das Team</a></li>
                        <li><a routerLink="/kurse">Kurse</a></li>
                        <li><a routerLink="/preise">Preise</a></li>
                        <li><a routerLink="/kurse">Ferienkurse</a></li>
                        <li><a routerLink="/kontakt">Kontakt</a></li>
                    </ul>
                </div>
            </div>

            <!-- Öffnungszeiten -->
            <div class="col-lg-3 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Öffnungszeiten</h3>
                    <ul class="list">
                        <li>Montag: 15:00 – 17:00 Uhr</li>
                        <li>Dienstag: 15:00 – 17:00 Uhr</li>
                        <li>Mittwoch: 15:00 – 17:00 Uhr</li>
                        <li>Donnerstag: 15:00 – 17:00 Uhr</li>
                        <li>Freitag: Nach Vereinbarung</li>
                    </ul>
                </div>
            </div>

            <!-- Kontaktinformationen -->
            <div class="col-lg-3 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Kontakt</h3>
                    <ul class="list">
                        <li><strong>Adresse:</strong><br>Bahnhofstraße 95<br>35390 Gießen</li>
                        <li><strong>Telefon:</strong><br><a href="tel:+491771482503">0177 - 148 250 3</a></li>
                        <li><strong>Festnetz:</strong><br><a href="tel:+4964120990375">0641 - 209 903 75</a></li>
                        <li><strong>E-Mail:</strong><br><a href="mailto:info@tommys-fs.de">info&commat;tommys-fs.de</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Copyright -->
<div class="copy-right">
    <div class="container">
        <div class="copy-right-content text-center">
            <p>© 2025 Tommys Fahrschule – Alle Rechte vorbehalten. |
                <a href="/datenschutz">Datenschutz</a> |
                <a href="/impressum">Impressum</a><br>
                Website erstellt von <a href="https://geekinstitut.com" target="_blank" rel="noopener">Geek Institut</a>
            </p>
        </div>
    </div>
</div>

<!-- Go to Top -->
<div class="go-top">
    <i class="fa fa-chevron-up"></i>
    <i class="fa fa-chevron-up"></i>
</div>
